import React from "react";
import { useNavigate } from "react-router-dom";
import ExternalLogin from "../../components/ExternalLogin/ExternalLogin";
import {
  verifyUserAndSendOtp,
  verifyOtpAndSignIn,
} from "../../network/externalApi";

const RK_BACKGROUND = "/images/external/rk_hero.png";
const RK_USER_TYPE = "railway_kitchen";

const RkLogin = () => {
  const navigate = useNavigate();

  const handleSendOtp = ({ phoneNumber }) =>
    verifyUserAndSendOtp({ phoneNumber });

  const handleVerifyOtp = ({ phoneNumber, otp }) =>
    verifyOtpAndSignIn({ phoneNumber, otp });

  const handleLoginSuccess = () => {
    navigate("/rk/home", { replace: true });
  };

  return (
    <ExternalLogin
      backgroundImage={RK_BACKGROUND}
      userType={RK_USER_TYPE}
      title="All your restaurant needs delivered next day"
      onSendOtp={handleSendOtp}
      onVerifyOtp={handleVerifyOtp}
      onLoginSuccess={handleLoginSuccess}
    />
  );
};

export default RkLogin;
